import React, { useEffect, useState } from 'react'
import CustomMultiSelect from '../customMultiSelect/customMultiSelect'
import { CCol, CFormCheck, CFormInput, CFormSelect, CRow } from '@coreui/react'
import { isEmpty } from 'lodash'

const CustomMetadata = ({
  isEdit,
  editData,
  customMetadataMaster,
  customPayload,
  setCustomPayload,
  colWidth = '',
  column = 2,
}) => {
  const [customMetadata, setCustomMetadata] = useState({ ...customPayload })

  // useEffect(() => {
  //   setCustomPayload(customMetadata)
  // }, [customMetadata])

  useEffect(() => {
    if (isEdit && !isEmpty(editData) && !isEmpty(customMetadataMaster)) {
      const metaObj = { ...editData['custom_metadata'] }
      const masterIds = customMetadataMaster.map((ele) => ele._id)
      Object.keys(metaObj).forEach((objKey) => {
        if (!masterIds.includes(objKey)) {
          delete metaObj[objKey]
        }
      })
      customMetadataMaster.forEach((item) => {
        metaObj[item._id] = {
          type: item.type,
          values: item.type === 'checkboxes' ? [] : '',
          name: item.name,
          ...metaObj[item._id],
        }
      })
      setCustomMetadata(metaObj)
    }
    if (!isEdit && !isEmpty(customMetadataMaster)) {
      // const metaObj = {}
      // customMetadataMaster.forEach((item) => {
      //   metaObj[item._id] = {
      //     type: item.type,
      //     values: item.type === 'checkboxes' ? [] : '',
      //     name: item.name,
      //   }
      // })
      // setCustomMetadata(metaObj)
    }
  }, [isEdit, editData, customMetadataMaster])

  const handleMetadata = (id, value) => {
    let tempObj = { ...customMetadata }
    tempObj[id] = { ...customMetadata[id], values: value }
    setCustomMetadata({ ...tempObj })
    setCustomPayload({ ...tempObj })
  }

  const dropDownComponent = (metaData) => {
    return (
      <CFormSelect
        value={customMetadata[metaData._id] ? customMetadata[metaData._id].values : ''}
        onChange={(e) => {
          handleMetadata(metaData._id, e.target.value)
        }}
        size="md"
        // defaultValue={selectedValues}
      >
        <option value="" disabled>
          Please select {metaData.name}
        </option>
        {!isEmpty(metaData.range_values) &&
          metaData.range_values.map((item, index) => (
            <option value={item} key={index}>
              {item}
            </option>
          ))}
      </CFormSelect>
    )
  }

  const multiSelectComponent = (metaData) => {
    const newData = metaData ? metaData.range_values.map((item) => ({ name: item })) : []
    return (
      <CustomMultiSelect
        selectedValue={customMetadata[metaData._id] ? customMetadata[metaData._id].values : []}
        optionsData={newData}
        onChange={(selected) => handleMetadata(metaData._id, selected)}
        labelKey="name"
        valueKey="name"
      />
    )
  }

  const textComponent = (metaData) => {
    return (
      <CFormInput
        size="md"
        placeholder={'Please provide ' + metaData.name}
        // defaultValue={selectedValues}
        value={customMetadata[metaData._id] ? customMetadata[metaData._id].values : ''}
        onChange={(e) => {
          handleMetadata(metaData._id, e.target.value)
        }}
      />
    )
  }

  const radioComponent = (metaData) => {
    return (
      <>
        {metaData.range_values &&
          metaData.range_values.map((item, index) => (
            <CFormCheck
              type="radio"
              key={index}
              label={item}
              name={metaData.name}
              value={item}
              // defaultValue={selectedValues}
              checked={
                customMetadata[metaData._id] ? customMetadata[metaData._id].values === item : false
              }
              onChange={(e) => handleMetadata(metaData._id, e.target.value)}
            />
          ))}
      </>
    )
  }

  return (
    <CRow xs={{ cols: column }} className=" justify-content-between align-items-center w-100">
      {customMetadataMaster &&
        customMetadataMaster.map((metaData, index) => (
          <CCol className={'mt-3 '} style={{ width: colWidth }} key={index}>
            <span style={{ fontSize: '0.833vw', fontWeight: 500 }}>{metaData.name}</span>

            {metaData.type === 'dropdown' && dropDownComponent(metaData)}
            {metaData.type === 'checkboxes' && multiSelectComponent(metaData)}
            {metaData.type === 'text' && textComponent(metaData)}
            {metaData.type === 'radio' && radioComponent(metaData)}
          </CCol>
        ))}
    </CRow>
  )
}

export default CustomMetadata
